import { FC } from 'react';
import styles from './Layouts.module.scss';
import { useLocation } from 'react-router-dom';

export const MainLayout: FC = ({ children }) => {
  // const dispatch = useAppDispatch();
  const location = useLocation();
  // const allSites: Site[] = useSelector(allUserSites);
  // const account = useAppSelector(selectAccount);
  // const fetchError: boolean = useAppSelector(allUserSitesFetchError);
  // const history = useHistory();

  // useFetchAllData();

  // useLayoutEffect(() => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const siteIdBySearchParams = searchParams.get('site');
  //
  //   if (!allSites || fetchError || !account) return;
  //
  //
  //   if (siteIdBySearchParams) {
  //     const currentSite = allSites.find((site) => site.id === siteIdBySearchParams);
  //     dispatch(siteSlice.actions.set_selected_site(currentSite));
  //     history.push({
  //       pathname: location.pathname,
  //       search: searchParams.toString(),
  //     });
  //     return;
  //   }
  //
  //   const currentSite = allSites[0];
  //   if (!currentSite) return;
  //   dispatch(siteSlice.actions.set_selected_site(currentSite));
  //   searchParams.set('site', currentSite.id);
  //   searchParams.set('widget', currentSite.widget?.id);
  //   void dispatch(fetchSite(currentSite.id));
  //   history.push({
  //     pathname: location.pathname,
  //     search: searchParams.toString(),
  //   });
  //
  //   void dispatch(getFonts());
  // }, [dispatch, allSites, fetchError, account, location.search, location.pathname, history]);

  const isDesignPage = location.pathname.includes('design');
  return (
    <main className={styles.main}>
      <div className={`${styles.content} ${isDesignPage ? styles.design : ''}`}>{children}</div>
    </main>
  );
};
